module.exports = __webpack_public_path__ + "img/Flag_of_Mozambique.bdc52af5.svg";